
import './App.css';

import CompShowBlogs from './blog/ShowBlogs';
import CompCreateBlog from './blog/CreateBlog';
import CompEditBlog from './blog/EditBlog';
import Login from './blog/Login';
import PrivateRoute from './PrivateRoute';
import CompEios from './blog/paginaM';
import {BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import MainLayout from './layout/MainLayout'


function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />

              <Route element={<PrivateRoute />}>
                <Route path="/app" element={<CompShowBlogs />} />
                <Route path="/edit/:id" element={<CompEditBlog />} />
                <Route path="/create" element={<CompCreateBlog />} />
              </Route>
            </Routes>
          </MainLayout>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
